
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { SpecialityTypeResponse } from "../../models/dtos";

export const specialityTypesApi = createApi({
  reducerPath: 'specialityTypesApi',
  baseQuery: baseAuthQuery('SpecialityTypes'),
  tagTypes: ['SpecialityType'],
  endpoints: (builder) => ({
    getSpecialityTypes: builder.query<ApiResponse<SpecialityTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['SpecialityType'],
    }),
    getSpecialityTypeById: builder.query<ApiResponse<SpecialityTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['SpecialityType'],
    }),
    updateSpecialityType: builder.mutation<ApiResponse<SpecialityTypeResponse>, Partial<SpecialityTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['SpecialityType'],
    }),
    deleteSpecialityType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['SpecialityType'],
    }),
  }),
});
